<template>
    <div>
        <div class="text-xl font-semibold">Text and background colors</div>
        <div class="mb-16 grid grid-flow-row grid-cols-3 gap-2">
            <div
                v-for="contentColor in textColors"
                :key="contentColor"
                class="flex flex-col"
            >
                <div class="flex flex-row gap-2">
                    <div
                        class="rounded p-2"
                        :class="[`text-${contentColor} bg-primary`]"
                    >
                        Veni
                    </div>
                    <div
                        class="rounded p-2"
                        :class="[`text-${contentColor} bg-secondary`]"
                    >
                        Vidi
                    </div>
                    <div
                        class="rounded p-2"
                        :class="[`text-${contentColor} bg-ds-primary-900`]"
                    >
                        Vici
                    </div>
                </div>
                <code>{{ contentColor }}</code>
            </div>
        </div>
        <div class="text-xl font-semibold">Semantic colors</div>
        <div
            v-for="semanticColor in semanticColors"
            :key="semanticColor"
        >
            <div class="text-xl font-semibold">{{ semanticColor }}</div>
            <div class="grid grid-flow-row grid-cols-10 gap-2">
                <div
                    v-for="semanticState in semanticStates"
                    :key="semanticState"
                >
                    <div
                        class="h-8 rounded-lg p-2"
                        :class="[`bg-semantic-${semanticColor}-${semanticState}`]"
                    ></div>

                    <code>{{ semanticState }}</code>
                </div>
            </div>
        </div>

        <div class="mt-16 text-xl font-semibold">Color families</div>
        <div
            v-for="colorFamily in colorFamilies"
            :key="colorFamily"
        >
            <div class="text-xl font-semibold">{{ colorFamily }}</div>
            <div class="grid grid-flow-row grid-cols-10 gap-2">
                <div
                    v-for="colorWeight in colorWeights"
                    :key="colorWeight"
                    class="p-2"
                >
                    <div
                        class="rounded-lg"
                        :class="[`bg-${colorFamily}-${colorWeight}`, 'h-8 p-2']"
                    ></div>
                    <code>{{ colorWeight }}</code>
                </div>
            </div>
        </div>
        <div class="my-6 text-xl font-semibold">Divider</div>
        <div class="bg-divide h-3 w-full">
            <div class="grid w-1/2 grid-cols-3 gap-2 divide-x-8 divide-default">
                <div>01</div>
                <div>02</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
/** Other color aliases exist but are not part of the design system */
const colorFamilies = ['ds-primary', 'ds-gray', 'ds-green', 'ds-blue', 'ds-cream', 'ds-orange', 'ds-yellow', 'ds-red'];
const colorWeights = ['50', '100', '200', '300', '400', '500', '600', '700', '800', '900'];

const textColors = [
    'content-primary',
    'content-secondary',
    'content-inverse',
    'content-error',
    'content-link',
    'content-disabled',
];

const semanticColors = ['primary', 'inverted', 'secondary', 'onDark', 'destructive-primary', 'destructive-secondary'];
const semanticStates = ['default', 'hover', 'pressed'];
</script>
